import React, { useState, useEffect, useMemo } from "react";
import { exams, exams as examsApi } from "../../../api/exams";
import { useTranslation } from "react-i18next";
import Loader from "../../../components/loader/Loader";
import Pagination from "../../../components/Pagination/Pagination";
import { api } from "../../../api";
import Card from "../dashboard/components/Card";
import { useMutation, useQuery } from "react-query";
import EmptyData from "../../../components/EmptyData";
import SurveyCard from "../dashboard/components/SurveyCard";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UpdatedRequestTable } from "../../../components/table/RequestTable";

const Reviewers = () => {
  const storedBranding = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding"));
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;

  const user = JSON.parse(sessionStorage.getItem("user"));
  const { t, i18n: i18nNext } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: summary, isLoading: summaryLoading } = useQuery(
    ["Summary Data"],
    async () => {
      const data = await api.getReviewerSurveySummary(user?.user?.user_id);
      return data;
    },
    {
      select: (response) => response?.data,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }
  );

  const { data: reviews, isLoading: reviewsLoading } = useQuery(
    ["reviews", currentPage, perPage, search],
    async () => {
      const data = await api.getOtherSurveysForUser({
        type: null, id: user?.user?.user_id, currentPage, perPage, search
      });
      return data;
    },
    {
      select: (data) => data,
      refetchOnWindowFocus: false,
    }
  );

  let columns = useMemo(
    () => [
      {
        title: t('id'),
        selector: null,
        key: "id",
        render: ({ index }) =>
          index +
          1 +
          ((reviews?.meta?.current_page || 1) - 1) *
          (reviews?.meta?.per_page || perPage),
      },
      {
        title: 'Assessment',
        selector: "userExam.assessment.preferred_exam_title",
        key: "assessment",
        render: ({ row }) => {
          return (
            <button
              className="text-baseFont"
              onClick={() => handleActionClick(row)}
            >
              {row?.userExam?.assessment?.preferred_exam_title || 'N/A'}
            </button>
          );
        },
      },
      {
        title: 'Review Type',
        selector: "reviewer.review_type",
        key: "reviewer",
        render: ({ row }) => {
          return (
            <button className="text-baseFont">
              {row?.review_type || 'N/A'}
            </button>
          );
        },
      },
      // {
      //   title: 'Reviewer',
      //   selector: "reviewer.name",
      //   key: "reviewer",
      //   render: ({ row }) => {
      //       return (
      //         <button className="text-baseFont">
      //           {row?.reviewer?.name || 'N/A'}
      //         </button>
      //       );
      //     },
      // },
      {
        title: 'Status',
        selector: "status",
        key: "status",
        render: ({ row }) => {
          const status = row?.status?.toLowerCase();
          return <div className="flex items-center gap-2">
            {
              status === 'pending' ?
                <span className="bg-orange-100 w-[100px] text-center text-orange-500 font-medium px-2 py-1 text-sm lg:text-base rounded-full capitalize">
                  {status}
                </span>
                :
                status === 'completed' ?
                  <span className="bg-green-100 w-[100px] text-center text-green-600 font-medium px-2 py-1 text-sm lg:text-base rounded-full capitalize">
                    {status}
                  </span>
                  :
                  <span className="bg-gray-100 w-[100px] text-center text-gray-700 font-medium px-2 py-1 text-sm lg:text-base rounded-full capitalize">
                    {status || 'N/A'}
                  </span>
            }
          </div>
        }
      },
      //   {
      //     title: t('action'),
      //     selector: null,
      //     key: null,
      //     render: ({row}) => {
      //       const status = row?.status?.toLowerCase();
      //       return <button 
      //                className={`rounded-full text-white py-2 px-5 text-sm
      //                 ${ status === 'completed' ? 'bg-gray-400' : 'bg-orange-500'  }
      //                `}
      //                onClick={() => takeSurvey(row)}
      //                disabled={status === 'completed'}
      //               >
      //               {
      //                 status === 'completed' ? 'Completed' : 'Evaluate'
      //               }
      //             </button>
      //     }
      //   },
    ], [reviews?.meta?.current_page, reviews?.meta?.per_page, perPage, t])
  return (
    <React.Fragment>
      {
        <>
          <h1
            className="text-white rounded-lg shadow bg-primary py-4 px-3 font-semibold"
            style={{ fontSize: "20px", marginTop: "0px", backgroundColor: appearance?.theme_colour }}
          >
            Reviewers Summary
          </h1>
          <p className="text-gray-600 text-lg mt-2">
            Overview of your reviewers and their evaluation status.
          </p>
          <div className="mb-12 mt-5 justify-between grid gap-5 grid-cols-1 md:grid-cols-3">
            <Card
              title={"Assigned"}
              text={summary?.assigned || 0}
              color="text-gray-900"
              bgColor={"bg-white"}
              isLoading={false}
              description={"Total evaluations assigned to you"}
              width="w-full"
            />
            <Card
              title={"Pending"}
              text={summary?.pending || 0}
              isLoading={false}
              bgColor={"bg-orange-50"}
              color="text-orange-500"
              description={"Evaluations yet to be completed"}
              width="w-full"
            />
            <Card
              title={"Completed"}
              bgColor={"bg-green-50"}
              text={summary?.completed || 0}
              isLoading={false}
              color="text-[#87AA4B]"
              description={"Total evaluations completed"}
              width="w-full"
            />
          </div>
          <div
            className="mt-1 gap-4"
            style={{
              display: "flex",
              width: "100%",
              // gridTemplateColumns: width > 768 ? "4fr 1.5fr" : "1fr",
              //  border: "1px solid #ccc",
            }}
          >
            <div className="w-full md:pt-0">
              <section>

                {
                  reviewsLoading ? (
                    <Loader />
                  ) :
                    !reviews?.data?.length > 0 ? (
                      <EmptyData text={'No Reviewers Found'} />
                    ) :
                      <>

                        <div className='max-[500px]:hidden shadow rounded-lg bg-white p-5'>
                          <h5 className="text-xl pb-3 border-b text-orange-500 font-medium" style={{ color: appearance?.theme_colour }}>All Reviewers</h5>
                          <UpdatedRequestTable
                            columns={columns}
                            data={reviews?.data}
                            isLoading={reviewsLoading}
                          />
                        </div>
                      </>

                }
              </section>
              <Pagination
                data={reviews?.meta}
                perPage={perPage}
                pageNo={currentPage}
                setPageNo={setCurrentPage}
                setPerPage={setPerPage}
              />
            </div>
          </div>
        </>
      }
    </React.Fragment>
  );
};

export default Reviewers;
